import { gql } from "@apollo/client";

export interface CreatePickUpMutation {
  createPickUp: boolean;
}

export const CREATE_PICKUP_MUTATION = gql`
    mutation CreatePickUp(
        $organizationId: ID!,
        $carId: String!,
        $name: String!,
        $street: String!,
        $postcode: String!,
        $city: String!,
        $country: String!,
        $phone: String!,
        $email: String!,
        $customerAgreedToPaidPickup: Boolean!,
        $returnData: ReturnData!
    ){
        createPickUp(
            organizationId: $organizationId,
            carId: $carId,
            name: $name,
            street: $street,
            postcode: $postcode,
            city: $city,
            country: $country,
            phone: $phone,
            email: $email,
            customerAgreedToPaidPickup: $customerAgreedToPaidPickup
            returnData: $returnData
        )
    }
`;
